'use client';

import {
  Conditional,
  Drawer,
  FooterCommonLink,
  useDrawer
} from '@cat-ecom/pcc-components';
import { Portal } from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import { useSisUrl } from 'hooks/use-sis-url';
import { FC, PropsWithChildren, useEffect } from 'react';

type SISLinkClientProps = {
  label: string;
  isLoggedIn: boolean;
  isFooterDesigneUpdate: boolean;
};

export const SISLinkClient: FC<PropsWithChildren<SISLinkClientProps>> = ({
  label,
  isLoggedIn,
  isFooterDesigneUpdate,
  children
}) => {
  const { drawerProps, isDrawerOpen, initiatorProps } = useDrawer();

  const userSisUrl = useSisUrl(isLoggedIn);

  const linkProps = {
    href: userSisUrl,
    ...(!isLoggedIn ? initiatorProps : {})
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      document.body.style.overflow = 'hidden';
    }
  }, [isDrawerOpen]);

  return (
    <>
      <FooterCommonLink
        isMobile={isFooterDesigneUpdate}
        label={label}
        {...linkProps}
      />

      <Conditional test={isDrawerOpen && !isLoggedIn}>
        <Portal id={ROOT_PORTALS}>
          <Drawer {...drawerProps}>{children}</Drawer>
        </Portal>
      </Conditional>
    </>
  );
};
